import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Vote: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm9 12 2 2 4-4' }],
    ['path', { d: 'M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z' }],
    ['path', { d: 'M22 19H2' }],
  ],
];

export default Vote;
